var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-header"},[_c('h2',[_vm._v("组织架构")])]),_c('div',{staticClass:"content-con"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../assets/images/353a3e8b-b658-4528-a477-887350ee9142.png"),"alt":""}})])])
}]

export { render, staticRenderFns }